<script setup>
import { getCountryProvincesAPI,addStoreOrderSteadyAPI,getcountryCodeAPI } from '@/apis/user'
import { getExchangeRateAPI } from '@/apis/wallet'
import { ElMessage } from 'element-plus'
import Prompt from '@/views/Member/components/Prompt.vue'
 import topUpView from '@/components/topUpView/index.vue'
import { getUserorOdersAPI,getPaymentMethodsAPI } from '@/apis/order'
import { handleCopy } from "@/hooks/useBtnLoading"; // 引入hooks
import { getBankListAPI } from '@/apis/wallet'
import { useUserStore } from '@/stores/userStore'
import {exchangeRateUSD,symbolStatus} from '@/utils/index'
import { useI18n } from 'vue-i18n'
const { t } = useI18n();
const userStore = useUserStore()
const countries=ref([])

// 调用自定义 Hook，获取公共方法
const { copy } = handleCopy();
const props=defineProps(['total'])
const emits=defineEmits(['getPayment'])
const param=reactive({
    payData:{
        pay_type:null,//支付类型
        checkCradItem:{},//银行数据
        PaymentFromdata:{},//第三方form数据
    }
})
const countryProvinces = async () => {
    const res = await getCountryProvincesAPI()
    if (res.code == 0) {
        countries.value=res.data.countries
    }
}

const provinceList=ref([])
const changeCountry=(value)=>{
    const obj = countries.value.find(item => item.name === value);
    provinceList.value=obj.provinces
    PaymentFromdata.form.billing_city=''
}
/**
 * 银行抽屉
 */
const drawer=ref()
const drawerClose = () => {
    drawer.value = false
}
/**
 * 第三方支付抽屉
 */
const drawerFrom=ref(false)
const drawerFromClose=()=>{
    drawerFrom.value=false
}
const phonecheck=(type)=>{
    if(type==2){
        if(isMobile.value){
        drawer.value = true
        }
    }
   
}
//选择银行
const checkCradItem = ref({})
// const setCard = (item) => {
//     checkCradItem.value = item
//     console.log(checkCradItem.value)

// }
// 选中银行时的回调
const selectedBankId=ref();
const handleBankChange=(bankId)=> {
    const selectedBank = bankList.value.find(item => item.id === bankId);
    // 执行后续操作，例如提交选中项
    console.log("Selected Bank:", selectedBank);
    param.payData.checkCradItem=selectedBank
    selectedBankId.value=selectedBank.id
    emits('getPayment',param.payData)
}
const handleBankChanges=(item)=>{
    console.log(item)
   if(item.credit_limit>pricetotal.value){
        const selectedBank = bankList.value.find(items => items.id ===  item.id);
        param.payData.checkCradItem=selectedBank
        selectedBankId.value=selectedBank.id
        emits('getPayment',param.payData)
   }else{
        ElMessage({ type: 'warning', message: t('setup577') }) 
   }
    
}

//判断选中的支付方式
const handleChange = (value) => {
    pay_type.value=value
    if (value == 1) {//商城币支付
        checkCradItem.value = {}
        param.payData.pay_type=1
        
    } else if (value == 2) {//转账支付
        param.payData.pay_type=2
        
    } else if (value == 3) {//ustd支付
        param.payData.pay_type=3
    } else if (value == 4) {//第三方跳转支付
        param.payData.pay_type=4
    }else if (value == 5) {//oceanpayment
        param.payData.pay_type=5
    }else if (value == 6) {//oceanpayment
        param.payData.pay_type=6
    }else if (value == 7) {//oceanpayment
        param.payData.pay_type=7
    }else if (value == 8) {//papal
        param.payData.pay_type=8
    }
    emits('getPayment',param.payData);
}

// const order_num=ref()
/**
 * 获取用户支付订单数
 */
// const getUserorOders=async ()=>{
//     const res = await getUserorOdersAPI()
//     if (res.code == 0) {
//         order_num.value = res.data.order_num
//     }
// }
/**
 * 第三方支付
 */
const pay_type = ref(1)
const PaymentFromdata=reactive({
    form:{
        order_no:'',
        shopper_phone:'',//手机号
        first_name:'',//名
        last_name:'',//姓
        billing_postal_code:'',//邮箱
        billing_country:'',//国家
        billing_state:'',//市
        billing_city:'',//省份
        billing_address:'',//详细地址
        area_code:'',//手机区号
    }
})

const paymentFormRef=ref()
const PaymentRules = {
    last_name: [
        { required: true, message: t('cart40'), trigger: 'blur' }
    ],
    first_name: [
        { required: true, message: t('cart41'), trigger: 'blur' },

    ],
    shopper_phone: [
        { required: true, message: t('cart42'), trigger: 'blur' }
    ],
    billing_country: [
        { required: true, message: t('cart43'), trigger: 'change' },

    ],
    billing_city: [
        { required: true, message: t('cart44'), trigger: 'change' }
    ],
    billing_state: [
        { required: true, message: t('cart45'), trigger: 'blur' },

    ],
    billing_address: [
        { required: true, message: t('cart46'), trigger: 'blur' },

    ],
    billing_postal_code: [
        { required: true, message: t('cart47'), trigger: 'blur' }
    ],
}
//验证第三方填写的参数是否填写
const paymentFormsubim=()=>{
    paymentFormRef.value.validate(async (valid) => {
        if (valid) {
           param.payData.PaymentFromdata =PaymentFromdata.form
           emits('getPayment',param.payData);
        }
    })
}
const usdData=ref()
const balance=ref()
const isNo=ref(false)
const pricetotal=ref()
/**
 * 获取汇率
 */
 const getExchangeRate = async () => {
    const res = await getExchangeRateAPI()
    if (res.code == 0) {
        usdData.value = res.data.USD;
        
    //   let  cnyData=res.data.CNY
        const Currency=userStore.exchangeRate.currency;
      
        let result=userStore.userInfo?.balance * usdData.value[Currency];
        if(Currency!='USD'){
           let dataRate=res.data[Currency];
           pricetotal.value=Number((props.total* dataRate['USD']).toFixed(3).slice(0, -1))
        }else{
            pricetotal.value=props.total
        }
       
       
        balance.value=`${symbolStatus(Currency)}${Number(result.toFixed(3).slice(0, -1))}`;//两位取两位
       
        let totalResult=props.total*userStore.exchangeRate.rate
      
        if(totalResult>result){
            isNo.value=true
        }
       
       
    } else {
        ElMessage({ type: 'error', message: res.message })
    }
}


/**
 * 获取银行
 */
const bankList = ref([])
const getBankList = async () => {
    let data = {
        status: 1,
        page: 1,
        page_size: 1000,
    }
    const res = await getBankListAPI(data)
    if (res.code == 0) {
        bankList.value = res.data.list
          // 根据输入金额更新银行列表的可选状态
     
    } else {
        ElMessage({ type: 'error', message: res.message })
    }
}

const codeAll=ref()
    /**
     * 获取手机号区号
     */
const countryCode=async ()=>{
    const res = await getcountryCodeAPI()
    if (res.code == 0) {
        codeAll.value = res.data.data
    }
}
/**
 * 
 * @param type 切换支付方式
 */
const checkRadio=(type)=>{
    
    pay_type.value=type
    if (type == 1) {//商城币支付
        checkCradItem.value = {}
        param.payData.pay_type=1
    } else if (type == 2) {//转账支付
        param.payData.pay_type=2
        drawer.value=true
    } else if (type == 3) {//ustd支付
        param.payData.pay_type=3
    } else if (type == 4) {//第三方跳转支付
        param.payData.pay_type=4
        drawerFrom.value=true
    }else if (type == 5) {//ustd支付
        param.payData.pay_type=5
    }else if (type == 6) {//Google Pay
        param.payData.pay_type=6
    }else if (type == 7) {//Apple Pay
        param.payData.pay_type=7
    }else if (type == 8) {//Paypal
        param.payData.pay_type=8
    }
    emits('getPayment',param.payData);
}
//充值模态框
const topUpVisible=ref(false)
const topUpClose = (value, type, id) => {
    topUpVisible.value = value
    if (type == 1) {
        orderSn.value = id
        PromptModel.value = true
    }
}
const orderSn = ref();
const PromptModel=ref(false)
const PromptClose = (value) => {
    PromptModel.value = value
}
/**
 * 获取支付方式
 */
const payList=ref()
const getPaymentMethods=async ()=>{
    
    const res = await getPaymentMethodsAPI();
    if(res.code==0){
        payList.value=res.data.list
    }
}
const checkCurrency=ref()
const isMobile = ref(false);
onMounted(() => {
    getPaymentMethods()
    console.log('bi',checkCurrency.value)
    console.log(userStore.userInfo.balance)
    getExchangeRate();
    getBankList()
    // getUserorOders()
    countryProvinces();
    countryCode();
    pay_type.value=1
    isMobile.value = /Mobi|Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
   
    
})
// 通过 defineExpose 暴露方法
defineExpose({
    paymentFormsubim,checkRadio
})
const confirm=()=>{
    drawerFrom.value=false
}
</script>
<template>
<div class="PaymentMethods">
     <!-- 支付方式 -->
    <div class="box-body" style="padding: 20px;" v-if="isMobile==false">
        <div class="box-title">
            {{ $t('setup25') }}
        </div>
        <el-radio-group v-model="pay_type" v-bind="$attrs" @change="handleChange" style="align-items: flex-start;flex-wrap: wrap;
        font-size: 0;display: flex;flex-direction: column;">
        <template v-for="(list,index) in payList" :key="index">
            <el-radio :label="list.type" style="height: 57px;width: 100%;" @click="phonecheck(list.type)">
                <div class="aboutflex" v-if="list.type==1">
                    <div class="elRadio">
                        <svg-icon icon-class="qianbao" style="width: 47px;height: 40px;"/>{{ $t('setup26') }}
                    </div>
                    <div style="display: flex;">
                        
                        <div class="topUpTest HorizontalCenter">
                            <!-- {{ usdData['USD'] }} -->
                           <span v-if="isNo==false">{{ balance }}</span> 
                           <span v-else>{{ $t('setup488') }}</span> 
                        </div>
                        <div class="topUp HorizontalCenter" @click="topUpVisible=true">{{ $t('number42') }}</div>
                    </div>
                </div>
                <div class="aboutflex" v-if="list.type==3">
                    <div class="elRadio" ><svg-icon icon-class="USDT" style="width: 47px;height: 35px;"/>{{ $t('setup102') }}
                    </div>
                </div>
                <div class="aboutflex" v-if="list.type==4">
                <div class="elRadio" >
                    <svg-icon icon-class="card" style="width: 47px;height: 35px;"/>Debit/Credit Card
                    <img src="../../assets/images/Payment6.png" alt="" srcset="">
                    <img src="../../assets/images/Payment1.png" alt="" srcset="">
                    <img src="../../assets/images/Payment7.png" alt="" srcset="">
                    <img src="../../assets/images/Payment22.png" alt="" srcset="">
                    <img src="../../assets/images/Payment33.png" alt="" srcset="">
                </div>
                </div>
                <div class="aboutflex" v-if="list.type==2">
                    <div class="elRadio"><svg-icon icon-class="zhuanzhang" style="width: 47px;height: 42px;"/>{{ $t('setup27') }}</div> 
                    <span v-if="list.type==2&&isMobile && checkCradItem.bank_name!=''">{{ checkCradItem.bank_name }}</span>
                </div>
                <div class="aboutflex" v-if="list.type==5">
                <div class="elRadio" >
                    <svg-icon icon-class="oceanpay" style="width: 47px;height: 35px;"/>Credit Card
                    <img src="../../assets/images/Payment6.png" alt="" srcset="">
                    <img src="../../assets/images/Payment1.png" alt="" srcset="">
                    <img src="../../assets/images/Payment7.png" alt="" srcset="">
                    <img src="../../assets/images/Payment22.png" alt="" srcset="">
                    <img src="../../assets/images/Payment33.png" alt="" srcset="">
                    <!-- <img src="../../assets/images/oceanpayment.png" alt="" srcset="" style="background-color: #328c3a !important;width: 120px;"> -->
                </div>
                </div>
                <div  class="aboutflex" v-if="list.type==6" >
                  
                    <div class="elRadio" >
                    <svg-icon icon-class="Googlepay" style="width: 47px;height: 35px;"/> Google Pay
                    <img src="../../assets/images/Google.png" alt="" srcset="" style="    padding: 5px 4px;">
                    </div>
                </div>
                <div  class="aboutflex" v-if="list.type==7">
                   
                   <div class="elRadio" >
                    <svg-icon icon-class="apple" style="width: 47px;height: 35px;"/> Apple Pay
                    <img src="../../assets/images/applepay.png" alt="" srcset="" style="    padding: 5px 4px;">
                    </div>
                </div>
                <div  class="aboutflex" v-if="list.type==8">
                   
                   <div class="elRadio" >
                    <svg-icon icon-class="paypal" style="width: 47px;height: 35px;"/> PayPal
                    <img src="../../assets/images/paypal.png" alt="" srcset="" style="width: 73px;    padding: 5px 4px;">
                    </div>
                </div>
            </el-radio>
            <div v-if="list.type==1" class="topUpTest alignflex" style="width: 1101px;margin-left: 25px;"> {{ $t('setup489') }}</div>
          
            <div v-if="list.type==4 && pay_type == 4" style="width: 100%;background: #f1f1f1;padding: 10px;">
                <div style="background: #f7f7f7;padding: 15px;">
                <el-form ref="paymentFormRef" :model="PaymentFromdata.form" :rules="PaymentRules" size="large" label-position="top">
                    
                        <div style="display: flex;justify-content: space-around;">
                            <div style="display: flex;width: 48%;justify-content: space-between;">
                                <div style="width: 48%;">
                                    <el-form-item :label="t('cart50')" prop="last_name">
                                        <el-input v-model="PaymentFromdata.form.last_name" :placeholder="t('cart50')"/>
                                    </el-form-item>
                                </div>
                                <div style="width: 48%;">
                                    <el-form-item :label="t('cart51')" prop="first_name">
                                        <el-input v-model="PaymentFromdata.form.first_name" :placeholder="t('cart51')"/>
                                    </el-form-item>
                                </div>
                            </div>
                            <div style="width: 48%;">
                                <el-form-item :label="t('cart57')" prop="shopper_phone">
                                    <el-input
                                
                                    v-model="PaymentFromdata.form.shopper_phone"
                                    :placeholder="t('cart57')"
                                    clearable
                                >
                                        <template #prepend>
                                            <el-form-item  prop="area_code">
                                                <el-select
                                                    v-model="PaymentFromdata.form.area_code"
                                                    filterable
                                                    style="width: 100px"
                                                    :placeholder="t('setup81')"
                                                    
                                                >
                                                    <el-option
                                                    v-for="o in codeAll"
                                                    :label="`${o.code}`"
                                                    :value="o.code"
                                                    :key="o.id"
                                                    ></el-option>
                                                    
                                                </el-select> 
                                            </el-form-item>
                                        </template>
                                    </el-input>
                                </el-form-item>
                            </div>
                        </div>
                        <div style="display: flex;justify-content: space-around;">
                            <div style="width: 48%;">
                                <el-form-item :label="t('cart52')" prop="billing_country">
                                    <el-select v-model="PaymentFromdata.form.billing_country" class="select-full-width"  filterable :placeholder="t('cart52')" @change="changeCountry">
                                        <el-option v-for="(item, i) in countries" :key="i" :label="item.name" :value="item.name" >
                                            {{ item.name }}
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                                
                            </div>
                        
                            <div style="width: 48%;">
                                <el-form-item :label="t('cart53')" prop="billing_city" >
                                    <el-select v-if="provinceList.length>0" v-model="PaymentFromdata.form.billing_city" class="select-full-width" :placeholder="t('cart53')" >
                                        <el-option v-for="(item, i) in provinceList" :key="i" :label="item.name" :value="item.name" >
                                            {{ item.name }}
                                        </el-option>
                                    </el-select>
                                    <el-input v-else v-model="PaymentFromdata.form.billing_city" :placeholder="t('cart53')"/>
                                </el-form-item>
                            </div>
                        </div>
                        <div style="display: flex;justify-content: space-around;">
                            <div style="width: 48%;"> 
                                <el-form-item :label="t('cart54')" prop="billing_state">
                                    <el-input v-model="PaymentFromdata.form.billing_state" :placeholder="t('cart54')"/>
                                </el-form-item>
                            </div>
                            <div style="width: 48%;">
                                <el-form-item :label="t('cart56')" prop="billing_postal_code">
                                    <el-input v-model="PaymentFromdata.form.billing_postal_code" :placeholder="t('cart56')"/>
                                </el-form-item>
                            </div>
                        </div>
                        <div style="display: flex;justify-content: space-around;">
                            <div style="width: 48%;">
                                <el-form-item :label="t('cart55')" prop="billing_address">
                                    <el-input v-model="PaymentFromdata.form.billing_address" type="textarea" :placeholder="t('cart55')"/>
                                </el-form-item>
                                
                            </div>
                            <div style="width: 48%;">
                                
                            </div>
                        </div>
                </el-form>
            </div>
            </div> 
            <div class="bankList" v-if="list.type==2 && pay_type == 2 && isMobile == false" style="    width: 100%;">
                <el-radio-group 
                v-model="selectedBankId" 
                @change="handleBankChange"
                class="card-radio-group"
                >
                    <div class="card-list">
                        <div  v-for="(item, i) in bankList"  :key="i" :class="selectedBankId == item.id ? 'checkItemCard' : 'card-item'" >
                            <el-radio :label="item.id" class="bank-card-radio" :disabled="pricetotal>item.credit_limit">
                                <div class="bank-name">{{ item.bank_name }}</div>
                            </el-radio>
                            <div class="bank-card-content" v-if="selectedBankId == item.id">
                                <div class="contact-info" >
                                    <div class="unselectable" v-if="item.telegram">
                                        <a :href="`${item.telegram}`" target="_blank"
                                            rel="nofollow" class="button" style="padding-right: 10px;" v-if="item.telegram">
                                            <img src="../../assets/images/telegram.png"
                                                style="width: 26px;height: 26px;border-radius: 50%;" alt=""
                                                srcset="">
                                        </a>
                                        <el-button type="warning" size="small" @click="copy(item.telegram)" style="margin-left: 10px;" plain>{{ $t('setup60') }}</el-button>
                                    </div>
                                    <div class="unselectable" v-if="item.whats_app">
                                            <a :href="`${item.whats_app}`" target="_blank"
                                        rel="nofollow" class="button" style="padding-right: 10px;"
                                        v-if="item.whats_app">
                                        <img src="../../assets/images/watch.png"
                                            style="width: 26px;height: 26px;border-radius: 50%;    " alt=""
                                            srcset="">
                                        </a>
                                        <el-button type="warning" size="small" @click="copy(item.whats_app)" style="margin-left: 10px;" plain>{{ $t('setup60') }}</el-button>
                                    </div>
                                </div>
                                <div class="copy" v-if="item.paypal_address" style="padding-top: 10px;">
                                    <el-input v-model="item.paypal_address" disabled style="width: 300px;" />
                                    <el-button type="warning" @click="copy(item.paypal_address)"
                                        style="margin-left: 10px;" size="small" plain>{{ $t('setup60') }}</el-button>
                                </div>
                            </div>
                        </div>
                    </div>
                </el-radio-group>
            </div>
        </template>
          
      
        </el-radio-group>
       
    </div>
    <div v-else class="phonePaymethods">
        <div class="radioDiv">
            <template v-for="(list,index) in payList" :key="index">
                <div class="radioitem"  >
                    <div class="aboutflex">
                        <div class="radioleft alignflex" v-if="list.type==1">
                            <svg-icon icon-class="qianbao" style="width: 47px;height: 40px;"/>{{ $t('setup26') }}
                        </div>
                        <div class="radioleft alignflex" v-if="list.type==3">
                            <svg-icon icon-class="USDT" style="width: 47px;height: 35px;"/>{{ $t('setup102') }}
                        </div>
                        <div class="radioleft alignflex" v-if="list.type==4">
                            <svg-icon icon-class="card" style="width: 47px;height: 35px;"/>Debit/Credit Card
                        </div>
                        <div class="radioleft alignflex"  v-if="list.type==2">
                            <svg-icon icon-class="zhuanzhang" style="width: 47px;height: 42px;"/>{{ $t('setup27') }}
                            <span v-if="isMobile && checkCradItem.bank_name!=''">{{ checkCradItem.bank_name }}</span>
                        </div>
                        <div class="radioleft alignflex" v-if="list.type==5">
                            <svg-icon icon-class="oceanpay" style="width: 47px;height: 35px;"/>Credit Card
                        </div>
                        <div class="radioleft alignflex" v-if="list.type==6">
                            <svg-icon icon-class="Googlepay" style="width: 47px;height: 35px;"/>Google Pay
                        </div>
                        <div class="radioleft alignflex" v-if="list.type==7">
                            <svg-icon icon-class="apple" style="width: 47px;height: 35px;"/>Apple Pay
                        </div> 
                        <div class="radioleft alignflex" v-if="list.type==8">
                            <svg-icon icon-class="paypal" style="width: 47px;height: 35px;"/>PayPal
                        </div>
                        <div class="radioRightImg" @click="checkRadio(list.type)">
                            <img src="../../assets/images/check.png" alt="" srcset="" v-if="pay_type==list.type" >
                            <img src="../../assets/images/nocheck.png" alt="" srcset="" v-else >
                        </div>
                       
                    </div>
                    <div class="hint aboutflex" v-if="list.type==1">
                        <div class="hintTest HorizontalCenter">
                            {{$t('setup489')}}</div>
                        <div class="hintbut HorizontalCenter" @click="topUpVisible=true">{{ $t('number42') }}</div>
                    </div>
                </div>
            </template>
            <!-- <div class="radioitem" >
                <div class="aboutflex">
                    <div class="radioleft alignflex">
                        <svg-icon icon-class="USDT" style="width: 47px;height: 35px;"/>{{ $t('setup102') }}
                    </div>
                    <div class="radioRightImg"  @click="checkRadio(3)">
                        <img src="../../assets/images/check.png" alt="" srcset="" v-if="pay_type==3">
                        <img src="../../assets/images/nocheck.png" alt="" srcset="" v-else >
                    </div>
                </div>
            </div>
            <div class="radioitem"  >
                <div class="aboutflex">
                    <div class="radioleft alignflex">
                         <svg-icon icon-class="card" style="width: 47px;height: 35px;"/>Debit/Credit Card
                    </div>
                    <div class="radioRightImg" @click="checkRadio(4);drawerFrom=true">
                        <img src="../../assets/images/check.png" alt="" srcset="" v-if="pay_type==4">
                        <img src="../../assets/images/nocheck.png" alt="" srcset="" v-else >
                    </div>
                </div> 
            </div>
            <div class="radioitem"  >
                <div class="aboutflex">
                    <div class="radioleft alignflex">
                        <svg-icon icon-class="zhuanzhang" style="width: 47px;height: 42px;"/>{{ $t('setup27') }}
                        <span v-if="isMobile && checkCradItem.bank_name!=''">{{ checkCradItem.bank_name }}</span>
                    </div>
                    <div class="radioRightImg" @click="checkRadio(2)">
                        <img src="../../assets/images/check.png" alt="" srcset="" v-if="pay_type==2">
                        <img src="../../assets/images/nocheck.png" alt="" srcset="" v-else >
                    </div>
               </div> 
            </div> -->
        </div>
     </div>
   
    <el-drawer v-model="drawer" :show-close="false"   direction="btt"  size="70%">
        <template #header="{ close}">
            <div :id="close" class="drawerIMG" @click="drawerClose"><img src="../../assets/images/closure.png" alt="" srcset=""></div>
        </template>
        <div class="drawerbankList">
            <div v-for="(item, i) in bankList" :key="i" @click="handleBankChanges(item)"
                class=" bankCard">
                <div class="item aboutflex">
                    <div class="name">{{ item.bank_name }}</div>
                    <div >
                        <img class="checkimg" src="../../assets/images/check.png" alt="" srcset="" v-if="selectedBankId == item.id">
                        <img  class="checkimg" src="../../assets/images/nocheck.png" alt="" v-else>
                    </div>
                </div>
                <div class="bank-card-content" v-if="selectedBankId == item.id">
                    <div class="contact-info" >
                        <div class="unselectable" v-if="item.telegram">
                            <a :href="`${item.telegram}`" target="_blank"
                                rel="nofollow" class="button" style="padding-right: 10px;" v-if="item.telegram">
                                <img src="../../assets/images/telegram.png"
                                    style="width: 26px;height: 26px;border-radius: 50%;" alt=""
                                    srcset="">
                            </a>
                            <el-button type="warning" size="small" @click="copy(item.telegram)" style="margin-left: 10px;" plain>{{ $t('setup60') }}</el-button>
                        </div>
                        <div class="unselectable" v-if="item.whats_app">
                                <a :href="`${item.whats_app}`" target="_blank"
                            rel="nofollow" class="button" style="padding-right: 10px;"
                            v-if="item.whats_app">
                            <img src="../../assets/images/watch.png"
                                style="width: 26px;height: 26px;border-radius: 50%;    " alt=""
                                srcset="">
                            </a>
                            <el-button type="warning" size="small" @click="copy(item.whats_app)" style="margin-left: 10px;" plain>{{ $t('setup60') }}</el-button>
                        </div>
                    </div>
                    <div class="inputcopy aboutflex" v-if="item.paypal_address"  >
                        <div style="padding-left: 8px;">{{item.paypal_address}}</div> 
                        <div class="copy HorizontalCenter" @click="copy(item.paypal_address)">
                            {{ $t('setup60') }}
                        </div>
                      
                    </div>
                </div>
            </div>
        </div>
        <template #footer>
        <div class="dialog-footer HorizontalCenter" @click="drawer=false">
            {{ $t('cart37') }}
        </div>
    </template>
        <!-- <div class="drawerbut">
            <el-button type="warning" class="btn" :disabled="Object.keys(checkCradItem).length ==0" >
                {{ $t("home4") }}
            </el-button>
        </div> -->
    </el-drawer>
    <el-drawer v-model="drawerFrom" :show-close="false"   direction="btt"  size="90%">
        <template #header="{ close}">
            <div :id="close" class="drawerIMG" @click="drawerFromClose"><img src="../../assets/images/closure.png" alt="" srcset=""></div>
        </template>
        <el-form ref="paymentFormRef" :model="PaymentFromdata.form" :rules="PaymentRules" size="large" label-position="top">
            <div class="aboutflex">
                <div style="width: 48%;">
                    <el-form-item :label="t('cart50')" prop="last_name">
                        <el-input v-model="PaymentFromdata.form.last_name" :placeholder="t('cart50')"/>
                    </el-form-item>
                </div>
                <div style="width: 48%;">
                    <el-form-item :label="t('cart51')" prop="first_name">
                        <el-input v-model="PaymentFromdata.form.first_name" :placeholder="t('cart51')"/>
                    </el-form-item>
                </div>
            </div>
            <div >
                <el-form-item :label="t('cart57')" prop="shopper_phone">
                    <el-input
                
                    v-model="PaymentFromdata.form.shopper_phone"
                    :placeholder="t('cart57')"
                    clearable
                >
                        <template #prepend>
                            <el-form-item  prop="area_code">
                                <el-select
                                    v-model="PaymentFromdata.form.area_code"
                                    filterable
                                    style="width: 100px"
                                    :placeholder="t('setup81')"
                                    
                                >
                                    <el-option
                                    v-for="o in codeAll"
                                    :label="`${o.code}`"
                                    :value="o.code"
                                    :key="o.id"
                                    ></el-option>
                                    
                                </el-select> 
                            </el-form-item>
                        </template>
                    </el-input>
                </el-form-item>
            </div>
            <div>
                <el-form-item :label="t('cart52')" prop="billing_country">
                    <el-select v-model="PaymentFromdata.form.billing_country" class="select-full-width"  filterable :placeholder="t('cart52')" @change="changeCountry">
                        <el-option v-for="(item, i) in countries" :key="i" :label="item.name" :value="item.name" >
                            {{ item.name }}
                        </el-option>
                    </el-select>
                </el-form-item>
                
            </div>
            <div>
                <el-form-item :label="t('cart53')" prop="billing_city" >
                    <el-select v-if="provinceList.length>0" v-model="PaymentFromdata.form.billing_city" class="select-full-width" :placeholder="t('cart53')" >
                        <el-option v-for="(item, i) in provinceList" :key="i" :label="item.name" :value="item.name" >
                            {{ item.name }}
                        </el-option>
                    </el-select>
                    <el-input v-else v-model="PaymentFromdata.form.billing_city" :placeholder="t('cart53')"/>
                </el-form-item>
            </div>
            <div > 
                <el-form-item :label="t('cart54')" prop="billing_state">
                    <el-input v-model="PaymentFromdata.form.billing_state" :placeholder="t('cart54')"/>
                </el-form-item>
            </div>
            <div >
                <el-form-item :label="t('cart56')" prop="billing_postal_code">
                    <el-input v-model="PaymentFromdata.form.billing_postal_code" :placeholder="t('cart56')"/>
                </el-form-item>
            </div>
            <div>
                <el-form-item :label="t('cart55')" prop="billing_address">
                    <el-input v-model="PaymentFromdata.form.billing_address" type="textarea" :placeholder="t('cart55')"/>
                </el-form-item>
            </div>
        </el-form>
        <template #footer>
            <div class="dialog-footer HorizontalCenter" @click="confirm()">
                <div >
                    {{ $t('cart8') }}
                </div>
            </div>
        </template>
    </el-drawer>
    <topUpView  v-if="topUpVisible" @handleClose="topUpClose" :model="topUpVisible"></topUpView>
    <Prompt v-if="PromptModel" :model="PromptModel" :id="orderSn" @Close="PromptClose"></Prompt>
</div>
</template>
<style scoped lang="scss">
:deep(.el-radio__label){
    width: 100%;
}
:deep(.el-drawer__body){
    padding: 20px;
}

.PaymentMethods{


    .box-body {
            width: 1200px;
            background: #FFFFFF;
            border-radius: 8px;
            padding: 20px 0;
                .box-title{
                    padding-top: 10px;
                    font-family: MicrosoftYaHei, MicrosoftYaHei;
                    font-weight: bold;
                    font-size: 18px;
                    color: #11192D;
                    line-height: 24px;
                    text-align: left;
                    font-style: normal;
                    padding-bottom: 5px;
                
                }
                .topUpTest{
                    height: 24px;
                    background: #FFF1EB;
                    border-radius: 4px;
                    padding:0 10px;
                    font-family: MicrosoftYaHei;
                    font-size: 12px;
                    color: #811414;
                    line-height: 16px;
                    text-align: left;
                    font-style: normal;
                    margin-right: 6px;
                }
                .topUp{
                    height: 26px;
                    padding: 0 8px;
                    background: #FFFFFF;
                    border-radius: 13px;
                    border: 1px solid #FC3938;
                    font-family: MicrosoftYaHei;
                    font-size: 12px;
                    color: #FC3938;
                    line-height: 16px;
                    text-align: left;
                    font-style: normal;
                }
                .elRadio{
                    color: #4a5568;
                    font-size: 14px;
                    font-weight: 600;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    img{
                        width: 57px;
                        height: 30px;
                        border: 1px solid #cfc8d8;
                        border-radius: 5px;
                        margin: 0 5px;
                        background: #fff;
                        padding: 0 4px;
                    }
                        
                }
    }
    .bankList {
        padding-top: 20px;
        .card-radio-group {
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            flex-wrap: wrap;
            font-size: 0;
        }
        .card-list{
            display: flex;
            flex-direction: column;
            width: 100%;
            .card-item {
                padding-top: 7px;
                padding-left: 14px;
                border-radius: 6px;
                width: 100%;
                .bank-card-radio{
                    padding: 12px 0;
                    .bank-name{
                        font-family: MicrosoftYaHei;
                        font-size: 14px;
                        color: #11192D;
                        line-height: 14px;
                        text-align: left;
                        font-style: normal;
                    }
                }
               
                
               
            }
            .checkItemCard {
                padding-top: 7px;
                width: 100%;
                padding-left: 14px;
                background: #FFF7F2;
                padding-bottom: 20px;
                border-radius: 6px;
            }
        }
        .bank-card-content{
            padding: 11px 0 0px 20px;
            .contact-info{
                display: flex;
                .unselectable{
                    margin-right: 40px;
                }
            }
        }

        .title {
            padding: 5px 0;
        }
    }
}
@media (max-width: 768px) {
    .dialog-footer{
        height: 40px;
        background: #ED4D34;
        border-radius: 20px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        font-size: 15px;
        color: #FFFFFF;
        line-height: 21px;
        text-align: left;
        font-style: normal;
    }
    .drawerIMG{
        width: 17px;
        height: 17px;
        text-align: end;
    }
    .checkimg{
                    width: 16px;
                    height: 16px;
                }
    .bank-card-content{
        padding-bottom: 20px;
    }
    .drawerbankList{
        .bankCard{
            border-bottom: 1px solid #F3F6F8;
            // padding-bottom: 22px;
            .item{
                padding: 16px 0;
                .name{
                    font-family: PingFangSC, PingFang SC;
                    font-weight: 400;
                    font-size: 14px;
                    color: #222222;
                    line-height: 16px;
                    text-align: left;
                    font-style: normal;
                }
                
                
            }
           
        }
        
    }
    .inputcopy{
        margin-top: 18px;
        width: 344px;
        height: 36px;
        background: #FFFFFF;
        border-radius: 4px;
        border: 1px solid #E5E8EC;
        .copy{
           
            height: 36px;
            background: #FF9845;
            border-radius: 0px 4px 4px 0px;
            font-family: MicrosoftYaHei;
            font-size: 14px;
            color: #FFFFFF;
            line-height: 19px;
            text-align: left;
            font-style: normal;
            // padding-top:22px;
            padding: 0 20px;
        }
    }
    .bank-card-content{
        .contact-info{
                display: flex;
                .unselectable{
                    margin-right: 40px;
                }
            }

    }
    .PaymentMethods{
        width: 100%;
    }
    .phonePaymethods{
        background: #FFFFFF;
        box-shadow: 5px 4px 20px 6px rgba(237,237,237,0.75);
        border-radius: 8px; 
        width: 100%;
        .radioDiv{
            width: 100%;
            padding: 5px 15px 5px 15px;
           .radioitem{
            padding: 15px 0;
            width: 100%;
            .hint{
                margin-top: 5px;
                padding: 5px 10px;
                background: #FFF1EB;
                border-radius: 4px; 
                .hintTest{
                    width: 213px;
                    font-family: MicrosoftYaHei;
                    font-size: 12px;
                    color: #811414;
                    line-height: 17px;
                    text-align: left;
                    font-style: normal;
                }
                .hintbut{
                    height: 26px;
                    border-radius: 13px;
                    border: 1px solid #FC3938;
                    font-family: PingFangSC, PingFang SC;
                    font-weight: 400;
                    font-size: 12px;
                    color: #FC3938;
                    line-height: 12px;
                    text-align: left;
                    font-style: normal;
                    padding: 0 8px;
                }

            }
                .radioleft{
                    font-family: MicrosoftYaHei;
                    font-size: 14px;
                    color: #11192D;
                    line-height: 34px;
                    text-align: left;
                    font-style: normal;
                }
                .radioRightImg{
                    width: 16px;
                    height: 16px;
                }
           } 
        } 
    } 
}
</style>